<template>
  <img class="thumbnail-preview ma-0" :src="imageData">
</template>

<script>
import documents from '@/services/api/documents'
import emptyImage from '@/assets/other/default_thumbnail.png'
import asicImage from '@/assets/other/asic_img.svg'
import encryptedImage from '@/assets/other/encrypted_pdf.svg'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    asic: {
      type: Boolean,
      default: false
    },
    encrypted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      emptyImageData: emptyImage,
      imageData: emptyImage
    }
  },
  watch: {

    id: {
      handler(newID) {
        if (this.encrypted) {
          this.imageData = encryptedImage
          return
        }
        if (!this.id && this.asic) {
          this.imageData = asicImage
        }
        if ((this.id !== null) && (this.id !== undefined) && (this.id.length > 0)) {
          this.thumbnailWatcher()
        }
      },
      immediate: true
    }
  },
  methods: {
    thumbnailWatcher() {
      this.getUrlImage(this.id).then((resp) => {
        this.imageData = resp
      })
    },
    getBase64(file) {
      const reader = new FileReader()
      return new Promise(resolve => {
        reader.onload = ev => {
          resolve(ev.target.result)
        }
        reader.readAsDataURL(file)
      })
    },
    async getUrlImage(id) {
      try {
        if ((id === undefined) || (id === null)) {
          return this.emptyImageData
        }
        const resp = await documents.getThumbnail(id)
        if ((resp) && (resp.size === 0)) {
          return new Promise(resolve => {
            resolve(this.emptyImageData)
          })
        }
        return this.getBase64(resp)
      } catch (error) {
        console.error(error)
        return this.emptyImageData
      }
    }
  }
}
</script>
<style scoped>
.thumbnail-preview {
  max-width: 210px;
    width: 100%;
    max-height: 297px;

    object-fit: cover;
    object-position: 100% 0;
}
.thumbnail-landscape-preview{
  width: 100%;
  max-width: 500px;
}
</style>
